import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from '@/utils/libs/axios';

export interface INotificationItem {
  id: number;
  title: string;
  message: string;
  payload: string | Record<string, unknown> | null;
  url_to: string | null;
  user_id: string;
  read_at: string | null;
  sent_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface IMarkAllAsReadResponse {
  message: string;
  updated_count: number;
}

export const NotificationService = {
  useGet: () =>
    useQuery<INotificationItem[]>({
      queryKey: ['notification'],
      queryFn: async () => {
        const response = await axiosInstance.get('/api/notification');

        return response.data;
      },
      refetchInterval: 60000,
    }),

  useMarkAsRead: () => {
    const queryClient = useQueryClient();

    return useMutation<INotificationItem, Error, number>({
      mutationFn: async (notificationId: number) => {
        const response = await axiosInstance.post(
          `/api/notification/mark-as-read/${notificationId}`,
        );

        return response.data;
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['notification'],
        });
      },
    });
  },

  useMarkAllAsRead: () => {
    const queryClient = useQueryClient();

    return useMutation<IMarkAllAsReadResponse, Error>({
      mutationFn: async () => {
        const response = await axiosInstance.post(
          '/api/notification/mark-all-as-read',
        );

        return response.data;
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['notification'],
        });
      },
    });
  },
};
